export default __webpack_public_path__ + "static/media/el9.1a5212ca.svg";